module.exports = __webpack_public_path__ + "static/media/eth.c53f4e5a.png";